'use client';

import { c as _c } from "react/compiler-runtime";
import type { ChainId } from '@morpho-org/blue-sdk';
import type { DashboardLendPositionsFilters } from '@/helpers/filter/table';
import type { UserLendPositionFacets } from '@/hooks/positions/userLendPositionsQuery';
import { AdvancedAssetFilter, TableNetworkFilter } from '@/components/common/TableAdvancedFilters';
import { userPositionFacetsToAssetItems } from '@/helpers/filter/vaultMasterFilter/getFacetFilters';
interface DashboardLendPositionsFiltersProps {
  filters?: DashboardLendPositionsFilters;
  onFiltersChange?: (filters: DashboardLendPositionsFilters) => void;
  disabled?: boolean;
  positionChainIds?: ChainId[];
  facets?: UserLendPositionFacets;
}
const DashboardLendPositionsFilters = t0 => {
  const $ = _c(45);
  const {
    filters,
    onFiltersChange,
    disabled: t1,
    positionChainIds,
    facets
  } = t0;
  const disabled = t1 === undefined ? false : t1;
  const t2 = facets?.collateralAssets;
  let t3;
  if ($[0] !== t2) {
    t3 = userPositionFacetsToAssetItems(t2);
    $[0] = t2;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const collateralAssets = t3;
  const t4 = facets?.loanAssets;
  let t5;
  if ($[2] !== t4) {
    t5 = userPositionFacetsToAssetItems(t4);
    $[2] = t4;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  const loanAssets = t5;
  let t6;
  if ($[4] !== filters?.chainIdsFilter || $[5] !== filters?.loanAssetIdsFilter || $[6] !== onFiltersChange) {
    t6 = collateralAssetIdsFilter => {
      onFiltersChange?.({
        collateralAssetIdsFilter,
        loanAssetIdsFilter: filters?.loanAssetIdsFilter ?? [],
        chainIdsFilter: filters?.chainIdsFilter ?? []
      });
    };
    $[4] = filters?.chainIdsFilter;
    $[5] = filters?.loanAssetIdsFilter;
    $[6] = onFiltersChange;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  const handleCollateralAssetIdsFilterChange = t6;
  let t7;
  if ($[8] !== filters?.chainIdsFilter || $[9] !== filters?.collateralAssetIdsFilter || $[10] !== onFiltersChange) {
    t7 = loanAssetIdsFilter => {
      onFiltersChange?.({
        collateralAssetIdsFilter: filters?.collateralAssetIdsFilter ?? [],
        loanAssetIdsFilter,
        chainIdsFilter: filters?.chainIdsFilter ?? []
      });
    };
    $[8] = filters?.chainIdsFilter;
    $[9] = filters?.collateralAssetIdsFilter;
    $[10] = onFiltersChange;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  const handleLoanAssetIdsFilterChange = t7;
  let t8;
  if ($[12] !== onFiltersChange) {
    t8 = chainIdsFilter => {
      onFiltersChange?.({
        collateralAssetIdsFilter: [],
        loanAssetIdsFilter: [],
        chainIdsFilter
      });
    };
    $[12] = onFiltersChange;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  const handleChainIdsFilterChange = t8;
  let t9;
  if ($[14] !== filters?.chainIdsFilter) {
    t9 = filters?.chainIdsFilter ?? [];
    $[14] = filters?.chainIdsFilter;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  const t10 = disabled || !facets;
  let t11;
  if ($[16] !== handleChainIdsFilterChange || $[17] !== positionChainIds || $[18] !== t10 || $[19] !== t9) {
    t11 = <TableNetworkFilter chainIdsFilter={t9} handleChainIdsFilterChange={handleChainIdsFilterChange} disabled={t10} availableChains={positionChainIds} page="dashboard_lend_positions" />;
    $[16] = handleChainIdsFilterChange;
    $[17] = positionChainIds;
    $[18] = t10;
    $[19] = t9;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] !== filters?.loanAssetIdsFilter) {
    t12 = filters?.loanAssetIdsFilter ?? [];
    $[21] = filters?.loanAssetIdsFilter;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  let t13;
  if ($[23] !== filters?.chainIdsFilter) {
    t13 = filters?.chainIdsFilter ?? [];
    $[23] = filters?.chainIdsFilter;
    $[24] = t13;
  } else {
    t13 = $[24];
  }
  const t14 = disabled || !facets;
  let t15;
  if ($[25] !== handleLoanAssetIdsFilterChange || $[26] !== loanAssets || $[27] !== t12 || $[28] !== t13 || $[29] !== t14) {
    t15 = <AdvancedAssetFilter label="loan" assets={loanAssets} assetIdsFilter={t12} chainIdsFilter={t13} handleAssetIdsFilterChange={handleLoanAssetIdsFilterChange} disabled={t14} showPTFilter={true} page="dashboard_lend_positions" />;
    $[25] = handleLoanAssetIdsFilterChange;
    $[26] = loanAssets;
    $[27] = t12;
    $[28] = t13;
    $[29] = t14;
    $[30] = t15;
  } else {
    t15 = $[30];
  }
  let t16;
  if ($[31] !== filters?.collateralAssetIdsFilter) {
    t16 = filters?.collateralAssetIdsFilter ?? [];
    $[31] = filters?.collateralAssetIdsFilter;
    $[32] = t16;
  } else {
    t16 = $[32];
  }
  let t17;
  if ($[33] !== filters?.chainIdsFilter) {
    t17 = filters?.chainIdsFilter ?? [];
    $[33] = filters?.chainIdsFilter;
    $[34] = t17;
  } else {
    t17 = $[34];
  }
  const t18 = disabled || !facets;
  let t19;
  if ($[35] !== collateralAssets || $[36] !== handleCollateralAssetIdsFilterChange || $[37] !== t16 || $[38] !== t17 || $[39] !== t18) {
    t19 = <AdvancedAssetFilter label="collateral" assets={collateralAssets} assetIdsFilter={t16} chainIdsFilter={t17} handleAssetIdsFilterChange={handleCollateralAssetIdsFilterChange} disabled={t18} showPTFilter={true} page="dashboard_lend_positions" />;
    $[35] = collateralAssets;
    $[36] = handleCollateralAssetIdsFilterChange;
    $[37] = t16;
    $[38] = t17;
    $[39] = t18;
    $[40] = t19;
  } else {
    t19 = $[40];
  }
  let t20;
  if ($[41] !== t11 || $[42] !== t15 || $[43] !== t19) {
    t20 = <div className="gap-lg max-sm:gap-x-lg max-sm:gap-y-sm flex flex-row flex-wrap items-center">{t11}{t15}{t19}</div>;
    $[41] = t11;
    $[42] = t15;
    $[43] = t19;
    $[44] = t20;
  } else {
    t20 = $[44];
  }
  return t20;
};
export default DashboardLendPositionsFilters;